import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask w-full h-full"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-week-model",
  ref: "target"
}
const _hoisted_4 = { class: "pad-20 flex-col gap-10" }
const _hoisted_5 = { class: "row gap-06" }
const _hoisted_6 = { class: "row gap-06" }
const _hoisted_7 = { class: "row gap-06" }
const _hoisted_8 = { class: "flex-row h-full gap-06 row-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "txt-warn" }

import { CreateTimeslotsRequest, FrequencyEnum, PersonLightResponse, SettingsApi, WeekModelByNameResponse, WeekModelResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { ApiError } from '@/models/share.model';
import { useAppUserStore } from '@/stores/appUser';
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Select from 'primevue/select';
import SharedService from "@/services/SharedService";
import { DateFormat } from "@/models/share.model";
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { format } from 'date-fns';
import EsFormField from '@/components/form/esFormField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esAddTimeslot',
  props: {
    selectedInstituteId: {},
    selectedHealthPro: {},
    header: {},
    isOpen: { type: Boolean },
    confirmMethod: { type: Function }
  },
  emits: ['modal-close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const appUserStore = useAppUserStore();
const toast = useToast();

const settingsApi = new SettingsApi(medServerApiConfig);

const frequencyOptions = ref<string[]>(Object.values(FrequencyEnum) as string[]);
const weekModelByNames = ref<WeekModelByNameResponse[]>([]);
const selectedWeekModels = ref<WeekModelByNameResponse>(undefined);
const createTimeslotsRequest = ref<CreateTimeslotsRequest>(undefined);

// Temporary solution until we add a form library
// => Probably after we upgrade from webpack to vite
const startDateRequiredError = ref<boolean>(false);
const endDateRequiredError = ref<boolean>(false);
const frequencyRequiredError = ref<boolean>(false);
const weekModelRequiredError = ref<boolean>(false);

const emits = __emit;

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const findWeekModelByInstitute = async () => {
  if (props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
     await settingsApi.findWeekModelByInstitute({instituteId: props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value})
      .then((result: WeekModelByNameResponse[]) => {
        weekModelByNames.value = result;
      }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
  }
}

const validateForm = () => {
  startDateRequiredError.value = !createTimeslotsRequest.value.startDate;
  endDateRequiredError.value = !createTimeslotsRequest.value.endDate;
  frequencyRequiredError.value = !createTimeslotsRequest.value.frequency;
  weekModelRequiredError.value = !createTimeslotsRequest.value.weekModelIds || createTimeslotsRequest.value.weekModelIds.length <= 0;

  return !startDateRequiredError.value && !endDateRequiredError.value && !frequencyRequiredError.value && !weekModelRequiredError.value;
}

const confirmFormModal = async() => {
  const isFormValid = validateForm();
  if (!isFormValid)  {
    throw ('error.DEFAULT');
  }
  try {
    await props.confirmMethod(createTimeslotsRequest.value);
  } catch {
    throw  t('error.DEFAULT');
  }
  
}

const onEndDateChange = (newDate: Date) => {
  createTimeslotsRequest.value.endDate = format(newDate, DateFormat.ISO_SMALL);
}

const onStartDateChange = (newDate: Date) => {
  createTimeslotsRequest.value.startDate = format(newDate, DateFormat.ISO_SMALL);
}

const updateFrequency = (newValue: FrequencyEnum) => {
  createTimeslotsRequest.value.frequency = newValue;
}

const updateWeekModel = (newValue: WeekModelByNameResponse) => {
  selectedWeekModels.value = newValue;
  createTimeslotsRequest.value.weekModelIds = newValue.weekModels.map((weekModelResponse: WeekModelResponse) => weekModelResponse.weekModelId);
}

watch(
    () => props.isOpen,
  async () => {
    if (props.isOpen) {
      findWeekModelByInstitute();
    }

    startDateRequiredError.value = false;
    endDateRequiredError.value = false;
    frequencyRequiredError.value = false;
    weekModelRequiredError.value = false;
    
    selectedWeekModels.value = undefined;

    createTimeslotsRequest.value = {
      startDate: undefined,
      endDate: undefined,
      frequency: undefined,
      weekModelIds: undefined
    }
  }
);



return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(EsFormField, {
                label: _unref(t)('settings.label.planning.modale.addTimeslot.startDate'),
                "is-mandatory": true,
                "field-id": "start-date",
                error: startDateRequiredError.value ? _unref(t)('settings.label.planning.modale.addTimeslot.startDateRequired') : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_esInputDateTime, {
                    id: "start-date",
                    dateTimeValue: createTimeslotsRequest.value.startDate ? new Date(createTimeslotsRequest.value.startDate): null,
                    dateFormat: _unref(DateFormat).DATEPICKER,
                    withTime: false,
                    range: false,
                    minDate: new Date(),
                    maxDate: createTimeslotsRequest.value.endDate ? new Date(createTimeslotsRequest.value.endDate) : null,
                    size: "small",
                    onUpdateDateTime: _cache[0] || (_cache[0] = ($event: any) => (onStartDateChange($event))),
                    "is-invalid": startDateRequiredError.value
                  }, null, 8, ["dateTimeValue", "dateFormat", "minDate", "maxDate", "is-invalid"])
                ]),
                _: 1
              }, 8, ["label", "error"]),
              _createVNode(EsFormField, {
                label: _unref(t)('settings.label.planning.modale.addTimeslot.endDate'),
                "is-mandatory": true,
                "field-id": "end-date",
                error: startDateRequiredError.value ? _unref(t)('settings.label.planning.modale.addTimeslot.endDateRequired') : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_esInputDateTime, {
                    id: "end-date",
                    dateTimeValue: createTimeslotsRequest.value.endDate ? new Date(createTimeslotsRequest.value.endDate) : null,
                    dateFormat: _unref(DateFormat).DATEPICKER,
                    withTime: false,
                    range: false,
                    minDate: createTimeslotsRequest.value.startDate ? new Date(createTimeslotsRequest.value.startDate): new Date(),
                    size: "small",
                    onUpdateDateTime: _cache[1] || (_cache[1] = ($event: any) => (onEndDateChange($event))),
                    "is-invalid": startDateRequiredError.value
                  }, null, 8, ["dateTimeValue", "dateFormat", "minDate", "is-invalid"])
                ]),
                _: 1
              }, 8, ["label", "error"]),
              _createVNode(EsFormField, {
                label: _unref(t)('settings.label.planning.modale.addTimeslot.frequency'),
                "is-mandatory": true,
                "field-id": "frequency",
                error: startDateRequiredError.value ? _unref(t)('settings.label.planning.modale.addTimeslot.frequencyRequired') : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Select), {
                    "label-id": "frequency",
                    modelValue: createTimeslotsRequest.value.frequency,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createTimeslotsRequest.value.frequency) = $event)),
                    options: frequencyOptions.value,
                    size: "small",
                    class: "w-full",
                    onValueChange: _cache[3] || (_cache[3] = ($event: any) => (updateFrequency($event))),
                    invalid: frequencyRequiredError.value
                  }, _createSlots({
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('common.frequency.' + slotProps.option)), 1)
                    ]),
                    _: 2
                  }, [
                    (createTimeslotsRequest.value.frequency)
                      ? {
                          name: "value",
                          fn: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('common.frequency.' + slotProps.value)), 1)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options", "invalid"])
                ]),
                _: 1
              }, 8, ["label", "error"]),
              _createVNode(EsFormField, {
                label: _unref(t)('settings.label.planning.modale.addTimeslot.weekModel'),
                "is-mandatory": true,
                "field-id": "week-model",
                error: startDateRequiredError.value ? _unref(t)('settings.label.planning.modale.addTimeslot.weekModelRequired') : undefined
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Select), {
                    "label-id": "week-model",
                    "model-value": selectedWeekModels.value,
                    options: weekModelByNames.value,
                    size: "small",
                    class: "w-full",
                    optionLabel: "name",
                    onValueChange: _cache[4] || (_cache[4] = ($event: any) => (updateWeekModel($event))),
                    invalid: weekModelRequiredError.value
                  }, _createSlots({ _: 2 }, [
                    (createTimeslotsRequest.value.weekModelIds)
                      ? {
                          name: "value",
                          fn: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(slotProps.value.name), 1)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["model-value", "options", "invalid"])
                ]),
                _: 1
              }, 8, ["label", "error"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _unref(SharedService).getIcon('exclamationmark-triangle', true, 'shareIcons'),
                  class: "img-warn icon-container"
                }, null, 8, _hoisted_9),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('settings.label.planning.modale.addTimeslot.warning')), 1)
              ])
            ]),
            _createVNode(_component_es_modal_footer, {
              confirmModalMethod: () => confirmFormModal(),
              confirmLabel: 'action.save',
              onModalCancel: _cache[5] || (_cache[5] = ($event: any) => (emits('modal-close')))
            }, null, 8, ["confirmModalMethod"])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})